<template>
  <p :class="$style.callStatus">{{callStatus}}</p>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapGetters } = createNamespacedHelpers('conference')

  export default {
    computed: mapGetters([
      'callStatus'
    ])
  }
</script>

<style module src="./call-status.css"></style>



// WEBPACK FOOTER //
// call-status.vue?01e11e68